var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.00003 7.14343C8.18308 7.14343 9.14213 6.18438 9.14213 5.00134C9.14213 3.81829 8.18308 2.85924 7.00003 2.85924C5.81699 2.85924 4.85794 3.81829 4.85794 5.00134C4.85794 6.18438 5.81699 7.14343 7.00003 7.14343Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7436 4.40797C12.0971 2.41823 9.60459 0.50293 7.00004 0.50293C4.39498 0.50293 1.90192 2.41957 0.256442 4.40797C-0.0281891 4.75178 -0.0281891 5.25089 0.256442 5.5947C0.670135 6.09461 1.53742 7.05963 2.69576 7.90281C5.613 10.0265 8.38064 10.0312 11.3043 7.90281C12.4627 7.05963 13.3299 6.09461 13.7436 5.5947C14.0274 5.25156 14.0289 4.75291 13.7436 4.40797ZM7.00004 2.0024C8.65374 2.0024 9.99897 3.34764 9.99897 5.00134C9.99897 6.65504 8.65374 8.00027 7.00004 8.00027C5.34634 8.00027 4.0011 6.65504 4.0011 5.00134C4.0011 3.34764 5.34634 2.0024 7.00004 2.0024Z",
    fill: "#1D4469"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorIconNew);
export default __webpack_public_path__ + "static/media/vectorIconNew.69ea59549e90f1d820c48c3bf7c9cc4b.svg";
export { ForwardRef as ReactComponent };